export function onlyDigits(value = '', maxLength) {
  const digits = String(value).replace(/\D/g, '');
  return maxLength ? digits.slice(0, maxLength) : digits;
}

export function maskCpf(value = '') {
  return onlyDigits(value, 11)
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/(\d{3})\.(\d{3})\.(\d{3})(\d{1,2})/, '$1.$2.$3-$4');
}

export function maskCnpj(value = '') {
  return onlyDigits(value, 14)
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4')
    .replace(/(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d{1,2})/, '$1.$2.$3/$4-$5');
}

export function maskCpfCnpj(value = '') {
  return onlyDigits(value).length > 11 ? maskCnpj(value) : maskCpf(value);
}

export function maskPhone(value = '') {
  const digits = onlyDigits(value, 11);
  if (digits.length <= 10) {
    return digits
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d{1,4})$/, '$1-$2');
  }
  return digits
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d{1,4})$/, '$1-$2');
}

export function maskCep(value = '') {
  return onlyDigits(value, 8).replace(/(\d{5})(\d{1,3})$/, '$1-$2');
}

export function maskPlate(value = '') {
  // Placa brasileira/Mercosul: 3 letras + 4 alfanuméricos (ABC1D23), aceita formato antigo AAA9999.
  return String(value)
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 7);
}

export function maskInternationalPhone(value = '') {
  const clean = String(value).replace(/[^\d+().\s-]/g, '');
  return clean.startsWith('+')
    ? `+${clean.slice(1).replace(/\+/g, '')}`.slice(0, 25)
    : clean.replace(/\+/g, '').slice(0, 25);
}

export function maskRegistration(value = '') {
  return String(value).toUpperCase().replace(/[^A-Z0-9./\s-]/g, '').slice(0, 30);
}

export function maskPostalCode(value = '') {
  return String(value).toUpperCase().replace(/[^A-Z0-9\s-]/g, '').slice(0, 16);
}

export function maskInteger(value = '') {
  return onlyDigits(value);
}

export function maskMoney(value = '') {
  const clean = String(value)
    .replace(/[^\d,.]/g, '')
    .replace(/\./g, ',');
  const [integer = '', cents = ''] = clean.split(',');
  const normalizedInteger = integer.replace(/\D/g, '');
  const normalizedCents = cents.replace(/\D/g, '').slice(0, 2);
  if (!normalizedInteger && !normalizedCents) return '';
  return clean.includes(',') ? `${normalizedInteger || '0'},${normalizedCents}` : normalizedInteger;
}

export function normalizeMoney(value = '') {
  if (typeof value === 'number') return value;
  const normalized = String(value).replace(/\./g, '').replace(',', '.').replace(/[^\d.]/g, '');
  return Number(normalized || 0);
}

export function applyMask(mask, value) {
  const masks = {
    cep: maskCep,
    cpf: maskCpf,
    cnpj: maskCnpj,
    cpfCnpj: maskCpfCnpj,
    integer: maskInteger,
    money: maskMoney,
    phone: maskPhone,
    internationalPhone: maskInternationalPhone,
    plate: maskPlate,
    postalCode: maskPostalCode,
    registration: maskRegistration,
  };
  return masks[mask] ? masks[mask](value) : value;
}

// Mascaras regionalizadas: no Brasil aplica CPF/CNPJ, telefone (00) 00000-0000
// e CEP 00000-000; nos demais paises mantem as genericas internacionais.
export function regionalMasks(countryCode = 'BR') {
  const isBR = String(countryCode || 'BR').toUpperCase() === 'BR';
  return {
    registration: isBR ? 'cpfCnpj' : 'registration',
    phone: isBR ? 'phone' : 'internationalPhone',
    postalCode: isBR ? 'cep' : 'postalCode',
  };
}
